define((require) => {
    "use strict";

    const _                        = require("underscore");
    const AbstractOwnedWidgetModel = require("shared/ui/experience/widgets/AbstractOwnedWidgetModel");

    const TYPE = "ProductWidget";

    /**
     * A product widget.
     *
     * @class ProductWidgetModel
     * @constructor
     */
    return AbstractOwnedWidgetModel.extend("ProductWidgetModel", {

        defaults: _.extend({}, AbstractOwnedWidgetModel.prototype.defaults, {
            defaultActionId: null,
            height: 20,
            icon: null, // can be generic-product, or a product widget for a specific ecommerce platform. See http://confluence.zmags.com/display/MOS/Configuring+the+product+widget
            type: TYPE,
            width: 20
        }),

        initialize() {
            AbstractOwnedWidgetModel.prototype.initialize.call(this);
        },

        fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        }
    }, {
        TYPE
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/productWidget/ProductWidgetModel.js